import { ButtonLink } from "@ui/ButtonLink";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Heading } from "@ui/typography/Heading";
import { Text } from "@ui/typography/Text";

export const CommunityCard = () => {
	return (
		<HStack spacing="large">
			<div class="icon-bg">
				<MaterialSymbol symbol="diversity_3" />
			</div>
			<VStack spacing="medium">
				<VStack spacing="small">
					<Heading as="h3" weight="semi-bold">
						Join the community
					</Heading>
					<Text color="fg3">
						Share ideas, wins, and get product news early.
					</Text>
				</VStack>
				<ButtonLink
					href="https://discord.gg/Mqa9XvqVb7"
					target="_blank"
					symbol={["hub", "open_in_new"]}
					symbolRelativeSize="even-larger"
					variant="tertiary"
				>
					Join Discord
				</ButtonLink>
			</VStack>
		</HStack>
	);
};
